<template>
  <div id="content" class="crpg-o-private-jet-content">

    <div class="crpg-o-private-jet-content__pic-1">
      <img
        :src="require('@/assets/img/privateJet/pic_1.png')"
        alt=""
      />
      <h1>{{ $t("privateJet.main") }}</h1>
      <div class="info">
        <div class="title">{{ $t("privateJet.title") }}</div>
        <div class="text">
          {{ $t("privateJet.text") }}
        </div>
        <div class="caption">{{ $t("privateJet.caption") }}</div>
      </div>
    </div>

    <div class="crpg-o-private-jet-content__frame">
      <div class="frame__inner">
        <h3>{{ $t("privateJet.benefits") }}</h3>
        <div class="price">{{ $t("privateJet.price") }}</div>
        <p>{{ $t("privateJet.contactUs") }}<br>{{ $t("privateJet.contactUs2") }}</p>
      </div>
    </div>

    <div class="crpg-o-private-jet-content__table">
      <h3>{{ $t("privateJet.airClub") }}</h3>
      <div class="subtitle">
        {{ $t("privateJet.approxPrice") }}<br>{{ $t("privateJet.approxPrice2") }}
      </div>
      <table
        ref="table"
        v-for="(table, t) in content"
        :key="t"
      >
        <tbody>
          <tr
            ref="title"
            v-for="(tr, i) in table.content"
            :key="i"
            :class="{ 'title': isIndex(i, 0) }"
          >
            <td
              ref="td"
              v-for="(line, j) in tr.td"
              :key="j"
              :class="[
                { 'no-border': isIndex(i, 0, j) },
                { 'th': isIndex(i, 1) }
              ]"
            >
              {{ line }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="crpg-o-private-jet-content__sub-info">
      <ul>
        <li>{{ $t("privateJet.30minFill") }}<br>{{ $t("privateJet.time2okinawa") }}</li>
        <li>{{ $t("privateJet.priceIncludes") }}</li>
        <li>{{ $t("privateJet.separatePayment") }}</li>
        <li>{{ $t("privateJet.contactUs4MoreInfo") }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import text from "@/assets/txt/private_jet.json";

var obj = text;
export default {
  name: "PrivateJetContent",

  data() {
    return {
      content: obj.tables,
    }
  },
  mounted() {
    const forColspanSecondTableTrs = this.$refs.title.filter(el => el.classList[0] ==="title");
    forColspanSecondTableTrs.forEach(el => {
      const children = el.children;
      for (let j = 0; j < children.length; j++) {
        children[j].colSpan = 2;
      }
    })

  },
  methods: {
    isIndex(i, index, j) {
      if (j) return i === index && j === index;
      return i === index;
    },
  },
  computed: {
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/templates/privateJet.scss";
</style>
